// import React, { useState, useEffect } from 'react';
// import Navbar from '../Components/Navbar';
// import Footer from '../Components/Footer';
// import Header from '../Components/Header';
// import axios from "../axiosInstance";
// import { 
//   Box, 
//   Table, 
//   TableBody, 
//   TableCell, 
//   TableContainer, 
//   TableHead, 
//   TableRow, 
//   Paper, 
//   Typography, 
//   CircularProgress, 
//   Alert, 
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Card,
//   CardContent,
//   TableSortLabel
// } from "@mui/material";
// import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
// import SearchIcon from '@mui/icons-material/Search';

// // Brand Colors
// const primaryColor = '#065A79';
// const secondaryColor = '#AD1C86';

// const TopReports = () => {
//   const [exams, setExams] = useState([]);
//   const [selectedExam, setSelectedExam] = useState('');
//   const [reportData, setReportData] = useState(null);
//   const [loadingExams, setLoadingExams] = useState(true);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [error, setError] = useState(null);
//   const [orderBy, setOrderBy] = useState('rank');
//   const [order, setOrder] = useState('asc');

//   // Fetch active exams on component mount
//   useEffect(() => {
//     fetchActiveExams();
//   }, []);

//   const fetchActiveExams = async () => {
//     try {
//       setLoadingExams(true);
//       const response = await axios.get('/api/v1/exam/active');
//       if (response.data.success) {
//         setExams(response.data.data || []);
//       } else {
//         setError('Failed to fetch exams list');
//       }
//     } catch (err) {
//       console.error('Error fetching active exams:', err);
//       setError(err.response?.data?.message || 'Error fetching exams list');
//     } finally {
//       setLoadingExams(false);
//     }
//   };

//   const fetchTopReport = async () => {
//     if (!selectedExam) {
//       setError('Please select an exam');
//       return;
//     }

//     try {
//       setLoadingReport(true);
//       setError(null);
//       const response = await axios.post('/api/v1/report/student/top/report', {
//         examId: selectedExam
//       });
      
//       if (response.data.success) {
//         setReportData(response.data.data);
//       } else {
//         setError(response.data.message || 'Failed to fetch report data');
//         setReportData(null);
//       }
//     } catch (err) {
//       console.error('Error fetching top report:', err);
//       setError(err.response?.data?.message || 'Error fetching report data');
//       setReportData(null);
//     } finally {
//       setLoadingReport(false);
//     }
//   };

//   const handleExamChange = (event) => {
//     setSelectedExam(event.target.value);
//     setReportData(null);
//     setError(null);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (selectedExam) {
//       fetchTopReport();
//     }
//   };

//   const handleSort = (property) => {
//     const isAsc = orderBy === property && order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');
//     setOrderBy(property);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString('en-IN', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getVerdictChip = (verdict) => {
//     const isPass = verdict === 'Pass';
//     return (
//       <Chip
//         label={verdict}
//         sx={{
//           backgroundColor: isPass ? '#4caf50' : '#f44336',
//           color: 'white',
//           fontWeight: 'bold',
//           '&:hover': {
//             backgroundColor: isPass ? '#45a049' : '#d32f2f',
//           }
//         }}
//         size="small"
//       />
//     );
//   };

//   const getSortedStudents = () => {
//     if (!reportData?.students) return [];
    
//     return [...reportData.students].sort((a, b) => {
//       let aValue = a[orderBy];
//       let bValue = b[orderBy];
      
//       if (orderBy === 'percentage' || orderBy === 'obtainedMarks') {
//         aValue = Number(aValue);
//         bValue = Number(bValue);
//       } else if (orderBy === 'studentName' || orderBy === 'studentParentName') {
//         aValue = aValue?.toLowerCase() || '';
//         bValue = bValue?.toLowerCase() || '';
//       } else if (orderBy === 'timeTaken') {
//         aValue = Number(aValue);
//         bValue = Number(bValue);
//       }
      
//       if (order === 'asc') {
//         return aValue > bValue ? 1 : -1;
//       } else {
//         return aValue < bValue ? 1 : -1;
//       }
//     });
//   };

//   const getRankBadge = (rank) => {
//     if (rank === 1) {
//       return <Box sx={{ 
//         width: 40, 
//         height: 40, 
//         borderRadius: '50%', 
//         background: `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})`,
//         color: 'white',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         fontWeight: 'bold',
//         fontSize: '1.2rem'
//       }}>🏆</Box>;
//     }
//     return <Box sx={{ 
//       width: 35, 
//       height: 35, 
//       borderRadius: '50%', 
//       backgroundColor: rank <= 3 ? '#ff9800' : primaryColor,
//       color: 'white',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontWeight: 'bold'
//     }}>
//       {rank}
//     </Box>;
//   };

//   return (
//     <>
//       <Navbar />
//       <Header />
//       <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f5f5f5', minHeight: 'calc(100vh - 64px)' }}>
//         <Box sx={{ maxWidth: 1400, margin: '0 auto' }}>
//           {/* Selection Form Card */}
//           <Card sx={{ 
//             mb: 4, 
//             borderRadius: 2,
//             boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//             borderTop: `4px solid ${secondaryColor}`
//           }}>
//             <CardContent>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
//                 <EmojiEventsIcon sx={{ color: secondaryColor, fontSize: 32 }} />
//                 <Typography variant="h5" sx={{ color: primaryColor, fontWeight: 'bold' }}>
//                   Student Performance Report
//                 </Typography>
//               </Box>
              
//               <form onSubmit={handleSubmit}>
//                 <Box sx={{ 
//                   display: 'flex', 
//                   flexDirection: { xs: 'column', sm: 'row' }, 
//                   gap: 2,
//                   alignItems: 'flex-end'
//                 }}>
//                   <FormControl fullWidth sx={{ flex: 1 }}>
//                     <InputLabel id="exam-select-label">Select Exam</InputLabel>
//                     <Select
//                       labelId="exam-select-label"
//                       value={selectedExam}
//                       onChange={handleExamChange}
//                       label="Select Exam"
//                       disabled={loadingExams}
//                       sx={{
//                         '& .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#e0e0e0',
//                         },
//                         '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: primaryColor,
//                         },
//                         '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                           borderColor: primaryColor,
//                         }
//                       }}
//                     >
//                       <MenuItem value="">
//                         <em>Choose an exam</em>
//                       </MenuItem>
//                       {exams.map((exam) => (
//                         <MenuItem key={exam._id || exam.id} value={exam._id || exam.id}>
//                           {exam.examName || exam.name} - {exam.examSubject || exam.subject} 
//                           ({exam.totalMarks || exam.marks} marks)
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
                  
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     disabled={!selectedExam || loadingReport}
//                     sx={{
//                       backgroundColor: primaryColor,
//                       '&:hover': {
//                         backgroundColor: '#043d54',
//                       },
//                       minWidth: { xs: '100%', sm: '150px' },
//                       height: '56px'
//                     }}
//                     startIcon={loadingReport ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
//                   >
//                     {loadingReport ? 'Loading...' : 'View Report'}
//                   </Button>
//                 </Box>
//               </form>
//             </CardContent>
//           </Card>

//           {/* Error Display */}
//           {error && (
//             <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//               {error}
//             </Alert>
//           )}

//           {/* Loading Report */}
//           {loadingReport && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
//               <CircularProgress sx={{ color: primaryColor }} />
//             </Box>
//           )}

//           {/* Report Display */}
//           {!loadingReport && reportData && (
//             <>
//               {/* Exam Summary Card */}
//               <Card sx={{ 
//                 mb: 4,
//                 borderRadius: 2,
//                 boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//                 borderLeft: `4px solid ${secondaryColor}`
//               }}>
//                 <CardContent>
//                   <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold', mb: 2 }}>
//                     Exam Summary
//                   </Typography>
//                   <Box sx={{ 
//                     display: 'grid', 
//                     gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, 
//                     gap: 3
//                   }}>
//                     <Box>
//                       <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Exam Name</Typography>
//                       <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>{reportData.examName}</Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Subject</Typography>
//                       <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>{reportData.examSubject}</Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Total Marks / Passing</Typography>
//                       <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>
//                         {reportData.totalMarks} / {reportData.passingMarks}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Topper's Score</Typography>
//                       <Typography variant="h6" sx={{ color: secondaryColor, fontWeight: 'bold' }}>
//                         {reportData.topMarks} / {reportData.totalMarks}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
//                     <Typography variant="body2" sx={{ color: '#666' }}>
//                       Total Students: <strong style={{ color: primaryColor }}>{reportData.totalPassStudents}</strong>
//                     </Typography>
//                   </Box>
//                 </CardContent>
//               </Card>

//               {/* Students Performance Table */}
//               <TableContainer 
//                 component={Paper} 
//                 sx={{ 
//                   borderRadius: 2,
//                   boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//                   overflowX: 'auto'
//                 }}
//               >
//                 <Table>
//                   <TableHead sx={{ backgroundColor: primaryColor }}>
//                     <TableRow>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'rank'}
//                           direction={orderBy === 'rank' ? order : 'asc'}
//                           onClick={() => handleSort('rank')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Rank
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'studentName'}
//                           direction={orderBy === 'studentName' ? order : 'asc'}
//                           onClick={() => handleSort('studentName')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Student Name
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'studentParentName'}
//                           direction={orderBy === 'studentParentName' ? order : 'asc'}
//                           onClick={() => handleSort('studentParentName')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Parent / Guardian
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Class</TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'obtainedMarks'}
//                           direction={orderBy === 'obtainedMarks' ? order : 'asc'}
//                           onClick={() => handleSort('obtainedMarks')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Obtained Marks
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'percentage'}
//                           direction={orderBy === 'percentage' ? order : 'asc'}
//                           onClick={() => handleSort('percentage')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Percentage
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Correct/Wrong/Skipped</TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Attempted</TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                         <TableSortLabel
//                           active={orderBy === 'timeTaken'}
//                           direction={orderBy === 'timeTaken' ? order : 'asc'}
//                           onClick={() => handleSort('timeTaken')}
//                           sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
//                         >
//                           Time Taken
//                         </TableSortLabel>
//                       </TableCell>
//                       <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Completed At</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {getSortedStudents().map((student) => (
//                       <TableRow 
//                         key={student.studentId}
//                         sx={{ 
//                           '&:hover': { backgroundColor: '#f5f5f5' },
//                           backgroundColor: student.rank === 1 ? '#fff9e6' : 'white'
//                         }}
//                       >
//                         <TableCell>{getRankBadge(student.rank)}</TableCell>
//                         <TableCell sx={{ fontWeight: 'bold', color: primaryColor }}>{student.studentName}</TableCell>
//                         <TableCell>{student.studentParentName}</TableCell>
//                         <TableCell>{student.studentClass}</TableCell>
//                         <TableCell>
//                           <Typography sx={{ fontWeight: 'bold', color: secondaryColor }}>
//                             {student.obtainedMarks} / {reportData.totalMarks}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography sx={{ 
//                             fontWeight: 'bold', 
//                             color: student.percentage >= 75 ? '#4caf50' : student.percentage >= 40 ? '#ff9800' : '#f44336'
//                           }}>
//                             {student.percentage}%
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getVerdictChip(student.verdict)}</TableCell>
//                         <TableCell>
//                           <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
//                             <Chip 
//                               label={`✓ ${student.correctAnswers}`} 
//                               size="small" 
//                               sx={{ backgroundColor: '#4caf50', color: 'white', fontSize: '0.7rem', height: '24px' }} 
//                             />
//                             <Chip 
//                               label={`✗ ${student.wrongAnswers}`} 
//                               size="small" 
//                               sx={{ backgroundColor: '#f44336', color: 'white', fontSize: '0.7rem', height: '24px' }} 
//                             />
//                             <Chip 
//                               label={`- ${student.skippedAnswers}`} 
//                               size="small" 
//                               sx={{ backgroundColor: '#9e9e9e', color: 'white', fontSize: '0.7rem', height: '24px' }} 
//                             />
//                           </Box>
//                         </TableCell>
//                         <TableCell>
//                           {student.attemptedQuestions} / {reportData.totalMarks}
//                         </TableCell>
//                         <TableCell>
//                           {Math.floor(student.timeTaken / 60)}m {student.timeTaken % 60}s
//                         </TableCell>
//                         <TableCell sx={{ fontSize: '0.85rem' }}>
//                           {formatDate(student.createdAt)}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </>
//           )}

//           {/* No report selected yet */}
//           {!loadingReport && !reportData && !error && (
//             <Card sx={{ 
//               textAlign: 'center', 
//               p: 6, 
//               borderRadius: 2,
//               backgroundColor: '#fafafa'
//             }}>
//               <EmojiEventsIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
//               <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
//                 No Report Selected
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#999' }}>
//                 Please select an exam from the dropdown and click "View Report" to see the student performance.
//               </Typography>
//             </Card>
//           )}
//         </Box>
//       </Box>
//       <Footer />
//     </>
//   );
// };

// export default TopReports;


import React, { useState, useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import ReportsBanner from "../assets/Reports.png";
import axios from "../axiosInstance";
import { 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Typography, 
  CircularProgress, 
  Alert, 
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  TableSortLabel,
  Grid
} from "@mui/material";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SearchIcon from '@mui/icons-material/Search';
import BarChartIcon from '@mui/icons-material/BarChart';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

// Brand Colors
const primaryColor = '#065A79';
const secondaryColor = '#AD1C86';

const TopReports = () => {
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState('');
  const [reportData, setReportData] = useState(null);
  const [loadingExams, setLoadingExams] = useState(true);
  const [loadingReport, setLoadingReport] = useState(false);
  const [error, setError] = useState(null);
  const [orderBy, setOrderBy] = useState('rank');
  const [order, setOrder] = useState('asc');

  // Fetch exams that have reports on component mount
  useEffect(() => {
    fetchExamsWithReports();
  }, []);

  const fetchExamsWithReports = async () => {
    try {
      setLoadingExams(true);
      const response = await axios.get('/api/v1/report/with-reports');
      if (response.data.success) {
        setExams(response.data.data || []);
      } else {
        setError('Failed to fetch exams list');
      }
    } catch (err) {
      console.error('Error fetching exams with reports:', err);
      setError(err.response?.data?.message || 'Error fetching exams list');
    } finally {
      setLoadingExams(false);
    }
  };

  const fetchTopReport = async () => {
    if (!selectedExam) {
      setError('Please select an exam');
      return;
    }

    try {
      setLoadingReport(true);
      setError(null);
      const response = await axios.post('/api/v1/report/student/top/report', {
        examId: selectedExam
      });
      
      if (response.data.success) {
        setReportData(response.data.data);
      } else {
        setError(response.data.message || 'Failed to fetch report data');
        setReportData(null);
      }
    } catch (err) {
      console.error('Error fetching top report:', err);
      setError(err.response?.data?.message || 'Error fetching report data');
      setReportData(null);
    } finally {
      setLoadingReport(false);
    }
  };

  const handleExamChange = (event) => {
    setSelectedExam(event.target.value);
    setReportData(null);
    setError(null);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedExam) {
      fetchTopReport();
    }
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getVerdictChip = (verdict) => {
    const isPass = verdict === 'Pass';
    return (
      <Chip
        label={verdict}
        sx={{
          backgroundColor: isPass ? '#4caf50' : '#f44336',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: isPass ? '#45a049' : '#d32f2f',
          }
        }}
        size="small"
      />
    );
  };

  const getSortedStudents = () => {
    if (!reportData?.students) return [];
    
    return [...reportData.students].sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];
      
      if (orderBy === 'percentage' || orderBy === 'obtainedMarks') {
        aValue = Number(aValue);
        bValue = Number(bValue);
      } else if (orderBy === 'studentName' || orderBy === 'studentParentName') {
        aValue = aValue?.toLowerCase() || '';
        bValue = bValue?.toLowerCase() || '';
      } else if (orderBy === 'timeTaken') {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }
      
      if (order === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
  };

  const getRankBadge = (rank) => {
    if (rank === 1) {
      return <Box sx={{ 
        width: 40, 
        height: 40, 
        borderRadius: '50%', 
        background: `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})`,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '1.2rem'
      }}>🏆</Box>;
    }
    return <Box sx={{ 
      width: 35, 
      height: 35, 
      borderRadius: '50%', 
      backgroundColor: rank <= 3 ? '#ff9800' : primaryColor,
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold'
    }}>
      {rank}
    </Box>;
  };

  return (
    <>
      <Navbar />
      <Header image={ReportsBanner} alt={"Shree Mangalam School"} />
      <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f5f5f5', minHeight: 'calc(100vh - 64px)' }}>
        <Box sx={{ maxWidth: 1400, margin: '0 auto' }}>
          
          {/* Hero Section - Title and Description */}
          <Box sx={{ 
            mb: 5, 
            textAlign: 'center',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -15,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: secondaryColor,
              borderRadius: '2px'
            }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
              {/* <SchoolIcon sx={{ color: secondaryColor, fontSize: 45 }} /> */}
              <Typography 
                variant="h4" 
                sx={{ 
                  color: primaryColor, 
                  fontWeight: 'bold',
                  fontSize: { xs: '1.8rem', sm: '2.5rem', md: '2.3rem' },
                  textShadow: '2px 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                Top Exam Performers
              </Typography>
              {/* <EmojiEventsIcon sx={{ color: secondaryColor, fontSize: 45 }} /> */}
            </Box>
            
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#555', 
                maxWidth: 850, 
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 'normal',
                mb: 1
              }}
            >
              Celebrating academic excellence at Shree Mangalam School
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                color: '#666', 
                maxWidth: 750, 
                mx: 'auto',
                lineHeight: 1.7
              }}
            >
              Track rankings, analyze results, and celebrate academic excellence. 
              View detailed performance reports of students who passed with flying colors. 
              Discover the brightest minds who've aced their examinations across different subjects.
            </Typography>
            
            {/* Stats Badges */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: 3, 
              mt: 3,
              flexWrap: 'wrap'
            }}>
              <Chip 
                icon={<TrendingUpIcon />} 
                label="Real-time Analytics" 
                sx={{ 
                  backgroundColor: primaryColor, 
                  color: 'white',
                  '& .MuiChip-icon': { color: 'white' }
                }} 
              />
              <Chip 
                icon={<EmojiEventsIcon />} 
                label="Top Performers" 
                sx={{ 
                  backgroundColor: secondaryColor, 
                  color: 'white',
                  '& .MuiChip-icon': { color: 'white' }
                }} 
              />
              <Chip 
                icon={<SchoolIcon />} 
                label="Exam Rankings" 
                sx={{ 
                  backgroundColor: '#ff9800', 
                  color: 'white',
                  '& .MuiChip-icon': { color: 'white' }
                }} 
              />
            </Box>
          </Box>

          {/* Selection Form Card */}
          <Card sx={{ 
            mb: 4, 
            borderRadius: 2,
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            borderTop: `4px solid ${secondaryColor}`
          }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <EmojiEventsIcon sx={{ color: secondaryColor, fontSize: 32 }} />
                <Typography variant="h5" sx={{ color: primaryColor, fontWeight: 'bold' }}>
                  Student Performance Report
                </Typography>
              </Box>
              
              <form onSubmit={handleSubmit}>
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: { xs: 'column', sm: 'row' }, 
                  gap: 2,
                  alignItems: 'flex-end'
                }}>
                  <FormControl fullWidth sx={{ flex: 1 }}>
                    <InputLabel id="exam-select-label">Select Exam</InputLabel>
                    <Select
                      labelId="exam-select-label"
                      value={selectedExam}
                      onChange={handleExamChange}
                      label="Select Exam"
                      disabled={loadingExams}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: primaryColor,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: primaryColor,
                        }
                      }}
                    >
                      <MenuItem value="">
                        <em>Choose an exam</em>
                      </MenuItem>
                      {exams.map((exam) => (
                        <MenuItem key={exam.examId || exam._id} value={exam.examId || exam._id}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span>{exam.examName} - {exam.examSubject}</span>
                            <span style={{ color: '#666', fontSize: '0.85rem', marginLeft: '10px' }}>
                              ({exam.totalStudents || 0} students)
                            </span>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={!selectedExam || loadingReport}
                    sx={{
                      backgroundColor: primaryColor,
                      '&:hover': {
                        backgroundColor: '#043d54',
                      },
                      minWidth: { xs: '100%', sm: '150px' },
                      height: '56px'
                    }}
                    startIcon={loadingReport ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
                  >
                    {loadingReport ? 'Loading...' : 'View Report'}
                  </Button>
                </Box>
              </form>

              {/* Exam Statistics Cards */}
              {exams.length > 0 && !selectedExam && (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="body2" sx={{ color: '#666', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BarChartIcon sx={{ fontSize: 18 }} />
                    Available Exams with Reports ({exams.length})
                  </Typography>
                  <Grid container spacing={2}>
                    {exams.slice(0, 3).map((exam) => (
                      <Grid item xs={12} sm={6} md={4} key={exam.examId || exam._id}>
                        <Card sx={{ backgroundColor: '#fafafa', borderLeft: `3px solid ${secondaryColor}` }}>
                          <CardContent>
                            <Typography variant="subtitle2" sx={{ color: primaryColor, fontWeight: 'bold' }}>
                              {exam.examName}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#666' }}>
                              {exam.examSubject}
                            </Typography>
                            <Box sx={{ mt: 1, display: 'flex', gap: 2 }}>
                              <Typography variant="caption">
                                Total: <strong>{exam.totalStudents || 0}</strong>
                              </Typography>
                              <Typography variant="caption">
                                Passed: <strong style={{ color: '#4caf50' }}>{exam.passedStudents || 0}</strong>
                              </Typography>
                              <Typography variant="caption">
                                Failed: <strong style={{ color: '#f44336' }}>{exam.failedStudents || 0}</strong>
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
            </CardContent>
          </Card>

          {/* Error Display */}
          {error && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
              {error}
            </Alert>
          )}

          {/* Loading Report */}
          {loadingReport && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <CircularProgress sx={{ color: primaryColor }} />
            </Box>
          )}

          {/* Report Display */}
          {!loadingReport && reportData && (
            <>
              {/* Exam Summary Card */}
              <Card sx={{ 
                mb: 4,
                borderRadius: 2,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                borderLeft: `4px solid ${secondaryColor}`
              }}>
                <CardContent>
                  <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold', mb: 2 }}>
                    Exam Summary
                  </Typography>
                  <Box sx={{ 
                    display: 'grid', 
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, 
                    gap: 3
                  }}>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Exam Name</Typography>
                      <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>{reportData.examName}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Subject</Typography>
                      <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>{reportData.examSubject}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Total Marks / Passing</Typography>
                      <Typography variant="h6" sx={{ color: primaryColor, fontWeight: 'bold' }}>
                        {reportData.totalMarks} / {reportData.passingMarks}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>Topper's Score</Typography>
                      <Typography variant="h6" sx={{ color: secondaryColor, fontWeight: 'bold' }}>
                        {reportData.topMarks} / {reportData.totalMarks}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      Total Passed Students: <strong style={{ color: primaryColor }}>
                        {reportData.totalPassStudents || reportData.students?.length || 0}
                      </strong>
                    </Typography>
                  </Box>
                </CardContent>
              </Card>

              {/* Students Performance Table */}
              <TableContainer 
                component={Paper} 
                sx={{ 
                  borderRadius: 2,
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  overflowX: 'auto'
                }}
              >
                <Table>
                  <TableHead sx={{ backgroundColor: primaryColor }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'rank'}
                          direction={orderBy === 'rank' ? order : 'asc'}
                          onClick={() => handleSort('rank')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Rank
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'studentName'}
                          direction={orderBy === 'studentName' ? order : 'asc'}
                          onClick={() => handleSort('studentName')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Student Name
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'studentParentName'}
                          direction={orderBy === 'studentParentName' ? order : 'asc'}
                          onClick={() => handleSort('studentParentName')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Parent Name
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Class</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'obtainedMarks'}
                          direction={orderBy === 'obtainedMarks' ? order : 'asc'}
                          onClick={() => handleSort('obtainedMarks')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Obtained Marks
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'percentage'}
                          direction={orderBy === 'percentage' ? order : 'asc'}
                          onClick={() => handleSort('percentage')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Percentage
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Correct/Wrong/Skipped</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Attempted</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                        <TableSortLabel
                          active={orderBy === 'timeTaken'}
                          direction={orderBy === 'timeTaken' ? order : 'asc'}
                          onClick={() => handleSort('timeTaken')}
                          sx={{ color: 'white', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                        >
                          Time Taken
                        </TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Completed At</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getSortedStudents().map((student) => (
                      <TableRow 
                        key={student.studentId}
                        sx={{ 
                          '&:hover': { backgroundColor: '#f5f5f5' },
                          backgroundColor: student.rank === 1 ? '#fff9e6' : 'white'
                        }}
                      >
                        <TableCell>{getRankBadge(student.rank)}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: primaryColor }}>{student.studentName}</TableCell>
                        <TableCell>{student.studentParentName}</TableCell>
                        <TableCell>{student.studentClass}</TableCell>
                        <TableCell>
                          <Typography sx={{ fontWeight: 'bold', color: secondaryColor }}>
                            {student.obtainedMarks} / {reportData.totalMarks}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography sx={{ 
                            fontWeight: 'bold', 
                            color: student.percentage >= 75 ? '#4caf50' : student.percentage >= 40 ? '#ff9800' : '#f44336'
                          }}>
                            {student.percentage}%
                          </Typography>
                        </TableCell>
                        <TableCell>{getVerdictChip(student.verdict)}</TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                            <Chip 
                              label={`✓ ${student.correctAnswers}`} 
                              size="small" 
                              sx={{ backgroundColor: '#4caf50', color: 'white', fontSize: '0.7rem', height: '24px' }} 
                            />
                            <Chip 
                              label={`✗ ${student.wrongAnswers}`} 
                              size="small" 
                              sx={{ backgroundColor: '#f44336', color: 'white', fontSize: '0.7rem', height: '24px' }} 
                            />
                            <Chip 
                              label={`- ${student.skippedAnswers}`} 
                              size="small" 
                              sx={{ backgroundColor: '#9e9e9e', color: 'white', fontSize: '0.7rem', height: '24px' }} 
                            />
                          </Box>
                        </TableCell>
                        <TableCell>
                          {student.attemptedQuestions} / {reportData.totalMarks}
                        </TableCell>
                        <TableCell>
                          {Math.floor(student.timeTaken / 60)}m {student.timeTaken % 60}s
                        </TableCell>
                        <TableCell sx={{ fontSize: '0.85rem' }}>
                          {formatDate(student.createdAt)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* No students message */}
              {(!reportData.students || reportData.students.length === 0) && (
                <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
                  No passed students found for this exam.
                </Alert>
              )}
            </>
          )}

          {/* No report selected yet */}
          {!loadingReport && !reportData && !error && exams.length === 0 && !loadingExams && (
            <Card sx={{ 
              textAlign: 'center', 
              p: 6, 
              borderRadius: 2,
              backgroundColor: '#fafafa'
            }}>
              <EmojiEventsIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
              <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
                No Exams Available
              </Typography>
              <Typography variant="body2" sx={{ color: '#999' }}>
                No exams with reports found. Please check back later.
              </Typography>
            </Card>
          )}

          {/* Loading Exams */}
          {loadingExams && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <CircularProgress sx={{ color: primaryColor }} />
            </Box>
          )}
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default TopReports;